import {Component, EventEmitter, Input, Output} from '@angular/core';

export type PlanType = 'monthly' | 'annual';

interface PlanCard {
  type: PlanType;
  title: string;
  subtitle: string;
  price: string;
  suffix: string;
  badgeLabel?: string;
  savingsLabel?: string;
  buttonLabel: string;
  features: string[];
  footerPoints: string[];
}

@Component({
  selector: 'app-plans-template',
  standalone: true,
  templateUrl: './plans-template.component.html'
})
export class PlansTemplateComponent {
  @Input() isLoading = false;
  @Output() planSelected = new EventEmitter<PlanType>();

  readonly plans: PlanCard[] = [
    {
      type: 'monthly',
      title: 'Mensal',
      subtitle: 'Ideal para começar com flexibilidade total.',
      price: '69',
      suffix: '/mês',
      buttonLabel: 'Começar teste grátis',
      features: [
        'Busque imóveis de leilão sem limites',
        'Receba alertas personalizados de oportunidades',
        'Simule custos estimados antes de decidir',
        'Acompanhe imóveis e datas importantes',
        'Acesso completo a todas as ferramentas Casato Brasil'
      ],
      footerPoints: [
        '7 dias de teste grátis',
        'Cancele quando quiser',
        'Pagamento seguro via Stripe'
      ]
    },
    {
      type: 'annual',
      title: 'Anual',
      subtitle: 'Ideal para quem quer economizar e aproveitar oportunidades o ano inteiro.',
      price: '690',
      suffix: '/anual',
      badgeLabel: 'Mais escolhido',
      savingsLabel: 'Economize R$98 por ano',
      buttonLabel: 'Começar teste grátis',
      features: [
        'Busque imóveis de leilão sem limites',
        'Receba alertas personalizados de oportunidades',
        'Simule custos estimados antes de decidir',
        'Acompanhe imóveis e datas importantes',
        'Acesso completo a todas as ferramentas Casato Brasil'
      ],
      footerPoints: [
        '7 dias de teste grátis',
        'Cancele quando quiser',
        'Pagamento seguro via Stripe'
      ]
    }
  ];

  selectPlan(planType: PlanType): void {
    if (!this.isLoading) {
      this.planSelected.emit(planType);
    }
  }
}
